<template>
  <div>
    <el-upload
      action=""
      :limit="1"
      :before-upload="beforeUpload"
      :on-exceed="handleExceed"
      :on-remove="handleRemove"
      :on-success="handleSuccess"
      accept=".doc,.docx"
      :file-list="fileList"
      :http-request="uploadFileApi"
      :show-file-list="false"
      ref="uploadRef"
      class="uploadFile"
      style="display: none"
    >
      <i class="el-icon-plus"></i>
    </el-upload>

    <quill-editor
      ref="myQuillEditor"
      v-model="content"
      v-maxWindow
      :options="editorOption"
      class="editor"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @change="onEditorChange($event)"
    />
  </div>
</template>
  
  <script>
import { quillEditor } from "vue-quill-editor";
import * as Quill from "quill"; //引入编辑器
import { addQuillTitle } from "./quill-title.js";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

// 自定义字体
let fontFamily = ["宋体", "黑体", "微软雅黑", "楷体", "仿宋", "Arial"];
Quill.imports["attributors/style/font"].whitelist = fontFamily;
Quill.register(Quill.imports["attributors/style/font"]);
// 自定义字号
let fontSize = [
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "22px",
  "24px",
  "28px",
  "32px",
  "36px",
];
Quill.imports["attributors/style/size"].whitelist = fontSize;
Quill.register(Quill.imports["attributors/style/size"]);
// 自定义文件上传
let Link = Quill.import("formats/link");
class FileBlot extends Link {
  // 继承Link Blot
  static create(value) {
    let node = undefined;
    if (value && !value.href) {
      // 适应原本的Link Blot
      node = super.create(value);
    } else {
      // 自定义Link Blot
      node = super.create(value.href);
      // node.setAttribute('download', value.innerText);  // 左键点击即下载
      node.innerText = value.innerText;
      node.download = value.innerText;
    }
    return node;
  }
}
FileBlot.blotName = "link";
FileBlot.tagName = "A";
Quill.register(FileBlot);

export default {
  name: "quillEditorPage",
  props: {
    editorContent: {
      type: String,
    },
  },
  components: { quillEditor },
  data() {
    return {
      content: this.editorContent,
      // content: '我是富文本内容',
      info: null,
      // 工具栏配置
      editorOption: {
        theme: "snow",
        // bounds: document.body,
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
              ["blockquote", "code-block"], // 引用  代码块
              [{ header: 1 }, { header: 2 }], // 1、2 级标题
              [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
              [{ script: "sub" }, { script: "super" }], // 上标/下标
              [{ indent: "-1" }, { indent: "+1" }], // 缩进
              // [{'direction': 'rtl'}], // 文本方向
              [{ size: fontSize }], // 字体大小
              // [{ size: ["small", false, "large", "huge"] }],
              // [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
              [{ color: [] }], // 字体颜色、
              [{ background: [] }], // 字体背景颜色
              // [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
              [{ font: fontFamily }], // 字体种类
              [{ align: [] }], // 对齐方式
              ["clean"], // 清除文本格式
              // ["link", "image", "upload"], // 链接、图片、视频
              // ["upload"],
              // ['link']
            ],
            handlers: {
              upload: (value) => {
                if (value) {
                  document.querySelector(".uploadFile .el-icon-plus").click();
                }
              },
              // link: (value) => {
              //   if (value) {
              //     document.querySelector('.uploadFile .el-icon-plus').click()
              //   }
              // }
            },
          },
        },
        placeholder: "请输入", //提示
      },
      fileList: [],
    };
  },
  created() {},
  mounted() {
    addQuillTitle();
    // 上传附件的图标
    // this.$el.querySelector(
    //   ".ql-upload"
    // ).innerHTML = `<svg t="1693300673548" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5709" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="200"><path d="M224 601.6v185.6a12.8 12.8 0 0 0 12.8 12.8h550.4a12.8 12.8 0 0 0 12.8-12.8V601.6a25.6 25.6 0 0 1 25.6-25.6h12.8a25.6 25.6 0 0 1 25.6 25.6v224a38.4 38.4 0 0 1-38.4 38.4H198.4a38.4 38.4 0 0 1-38.4-38.4v-224a25.6 25.6 0 0 1 25.6-25.6h12.8a25.6 25.6 0 0 1 25.6 25.6z m315.152-427.696l160 160a25.6 25.6 0 0 1 0 36.192l-9.056 9.056a25.6 25.6 0 0 1-36.192 0l-104.448-104.416a3.2 3.2 0 0 0-5.456 2.256V614.4a25.6 25.6 0 0 1-25.6 25.6h-12.8a25.6 25.6 0 0 1-25.6-25.6V276.992a3.2 3.2 0 0 0-5.456-2.256l-104.448 104.416a25.6 25.6 0 0 1-36.192 0l-9.056-9.056a25.6 25.6 0 0 1 0-36.192l160-160a38.4 38.4 0 0 1 54.304 0z" fill="#000000" p-id="5710"></path></svg>`;
  },
  computed: {},
  watch: {},
  methods: {
    // 失去焦点事件
    onEditorBlur(quill) {
      // console.log(quill,'失去焦点事件------');
    },
    // 获得焦点事件
    onEditorFocus(quill) {
      // console.log(quill,'获得焦点事件------');
    },
    // 内容改变事件
    onEditorChange({ quill, html, text }) {
      // console.log(quill, html, text, "内容改变事件------");
      this.info = html;
      this.$emit("change", this.info);
    },
    beforeUpload(file) {},
    handleExceed() {
      this.$message.warning("每次只能上传一个文件！");
    },
    // 移除文件
    handleRemove() {
      this.fileList = [];
    },

    handleSuccess(res, file) {
      this.$refs.uploadRef.clearFiles(); // 上传成功之后清除历史记录
    },
    async uploadFileApi(file) {
      let fromData = new FormData();
      fromData.append("file", file.file);
      await testApi
        .uploadLabel(fromData)
        .then((res) => {
          // 根据实际需求请求接口
          if (res.code === 200) {
            this.$message.success(res.message);
            let fileNameLength = res.file.name.length;
            // 插入链接 获取富文本组件实例
            let quill = this.$refs.myQuillEditor.quill;
            let length = quill.getSelection().index;
            quill.insertEmbed(
              length,
              "link",
              { href: res.msg, innerText: res.file.name },
              "api"
            );
            // quill.insertEmbed(length, 'link', { href: res.data, innerText: file.name })
            quill.setSelection(length + fileNameLength);
            this.fileList = [];
          }
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    },
  },
};
</script>
  <style lang="scss" scoped>
::v-deep .editor {
  line-height: normal !important;
  .ql-editor {
    min-height: 100px !important;
    height: auto;
  }
}
::v-deep .ql-container {
  min-height: 300px;
}
/*
这里一定要写上，是用来把相关改变的配置在工具栏正常显示
如果不写，字体样式的下拉会重复显示Sans Serif，字体大小的下拉会重复显示Normal
*/
::v-deep .editor .ql-picker.ql-font .ql-picker-label[data-value="宋体"]::before,
::v-deep .editor.ql-picker.ql-font .ql-picker-item[data-value="宋体"]::before {
  content: "宋体";
  font-family: "SimSun";
}
::v-deep .editor .ql-picker.ql-font .ql-picker-label[data-value="黑体"]::before,
::v-deep .editor .ql-picker.ql-font .ql-picker-item[data-value="黑体"]::before {
  content: "黑体";
  font-family: "SimHei";
}
::v-deep
  .editor
  .ql-picker.ql-font
  .ql-picker-label[data-value="微软雅黑"]::before,
::v-deep
  .editor
  .ql-picker.ql-font
  .ql-picker-item[data-value="微软雅黑"]::before {
  content: "微软雅黑";
  font-family: "Microsoft YaHei";
}
::v-deep .editor .ql-picker.ql-font .ql-picker-label[data-value="楷体"]::before,
::v-deep .editor .ql-picker.ql-font .ql-picker-item[data-value="楷体"]::before {
  content: "楷体";
  font-family: "KaiTi";
}
::v-deep .editor .ql-picker.ql-font .ql-picker-label[data-value="仿宋"]::before,
::v-deep .editor .ql-picker.ql-font .ql-picker-item[data-value="仿宋"]::before {
  content: "仿宋";
  font-family: "FangSong";
}
::v-deep
  .editor
  .ql-picker.ql-font
  .ql-picker-label[data-value="Arial"]::before,
::v-deep
  .editor
  .ql-picker.ql-font
  .ql-picker-item[data-value="Arial"]::before {
  content: "Arial";
  font-family: "Arial";
}
::v-deep
  .editor
  .ql-snow
  .ql-picker.ql-size
  .ql-picker-label[data-value="12px"]::before,
::v-deep
  .editor
  .ql-snow
  .ql-picker.ql-size
  .ql-picker-item[data-value="12px"]::before {
  content: "12px";
}
::v-deep
  .editor
  .ql-snow
  .ql-picker.ql-size
  .ql-picker-label[data-value="12px"]::before,
::v-deep
  .editor
  .ql-snow
  .ql-picker.ql-size
  .ql-picker-item[data-value="12px"]::before {
  content: "12px";
}
::v-deep
  .editor
  .ql-snow
  .ql-picker.ql-size
  .ql-picker-label[data-value="14px"]::before,
::v-deep
  .editor
  .ql-snow
  .ql-picker.ql-size
  .ql-picker-item[data-value="14px"]::before {
  content: "14px";
}
::v-deep
  .editor
  .ql-snow
  .ql-picker.ql-size
  .ql-picker-label[data-value="16px"]::before,
::v-deep
 .editor .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
  content: "16px";
}
::v-deep
  .editor
  .ql-snow
  .ql-picker.ql-size
  .ql-picker-label[data-value="18px"]::before,
::v-deep
  .editor
  .ql-snow
  .ql-picker.ql-size
  .ql-picker-item[data-value="18px"]::before {
  content: "18px";
}
::v-deep
  .editor
  .ql-snow
  .ql-picker.ql-size
  .ql-picker-label[data-value="20px"]::before,
::v-deep
  .editor
  .ql-snow
  .ql-picker.ql-size
  .ql-picker-item[data-value="20px"]::before {
  content: "20px";
}
::v-deep
 .editor .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="22px"]::before,
::v-deep
  .editor
  .ql-snow
  .ql-picker.ql-size
  .ql-picker-item[data-value="22px"]::before {
  content: "22px";
}
::v-deep
  .editor
  .ql-snow
  .ql-picker.ql-size
  .ql-picker-label[data-value="24px"]::before,
::v-deep
  .editor
  .ql-snow
  .ql-picker.ql-size
  .ql-picker-item[data-value="24px"]::before {
  content: "24px";
}
::v-deep
 .editor .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="26px"]::before,
::v-deep
  .editor
  .ql-snow
  .ql-picker.ql-size
  .ql-picker-item[data-value="26px"]::before {
  content: "26px";
}
::v-deep
  .editor
  .ql-snow
  .ql-picker.ql-size
  .ql-picker-label[data-value="28px"]::before,
::v-deep
  .editor
  .ql-snow
  .ql-picker.ql-size
  .ql-picker-item[data-value="28px"]::before {
  content: "28px";
}
::v-deep
  .editor
  .ql-snow
  .ql-picker.ql-size
  .ql-picker-label[data-value="30px"]::before,
::v-deep
  .editor
  .ql-snow
  .ql-picker.ql-size
  .ql-picker-item[data-value="30px"]::before {
  content: "30px";
}
::v-deep
  .editor
  .ql-snow
  .ql-picker.ql-size
  .ql-picker-label[data-value="32px"]::before,
::v-deep
  .editor
  .ql-snow
  .ql-picker.ql-size
  .ql-picker-item[data-value="32px"]::before {
  content: "32px";
}
::v-deep
  .editor
 .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="36px"]::before,
::v-deep
  .editor
  .ql-snow
  .ql-picker.ql-size
  .ql-picker-item[data-value="36px"]::before {
  content: "34px";
}
</style>
  